module.exports = __webpack_public_path__ + "static/media/148.d18f617a.jpg";